/* eslint-disable no-plusplus */

export const decodeHtmlEntities = (text) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

export const tryParseJSON = (str) => {
  if (typeof str !== 'string') return null;
  const trimmed = str.trim();
  if (
    (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
    (trimmed.startsWith('[') && trimmed.endsWith(']'))
  ) {
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const parseXML = (xmlString) => {
  let fixedXml = xmlString;
  fixedXml = fixedXml.replace(/&(?!(amp|lt|gt|quot|apos|#\d+|#x[0-9a-fA-F]+);)/g, '&amp;');

  const xmlDeclMatch = xmlString.match(/<\?xml[^?]*\?>/i);
  const parser = new DOMParser();
  const doc = parser.parseFromString(fixedXml, 'text/xml');

  if (doc.querySelector('parsererror')) return null;

  const parseNode = (node, id = '0') => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.trim();
      return text ? { type: 'text', content: text } : null;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const children = [];
      for (let i = 0; i < node.childNodes.length; i++) {
        const child = parseNode(node.childNodes[i], `${id}-${i}`);
        if (child) children.push(child);
      }
      const attributes = {};
      for (let i = 0; i < node.attributes.length; i++) {
        attributes[node.attributes[i].name] = node.attributes[i].value;
      }
      return { type: 'element', id, tagName: node.tagName, attributes, children };
    }
    return null;
  };

  return {
    xmlDeclaration: xmlDeclMatch ? xmlDeclMatch[0] : null,
    root: parseNode(doc.documentElement),
  };
};

export const collectNodeIds = (node) => {
  if (!node || node.type !== 'element') return [];
  const ids = [node.id];
  (node.children || []).forEach((child) => {
    ids.push(...collectNodeIds(child));
  });
  return ids;
};

export const collectJsonIds = (value, depth = 0, keyName = null) => {
  const isObject = value !== null && typeof value === 'object';
  if (!isObject) return [];
  const id = `${depth}-${keyName}`;
  const ids = [id];
  const entries = Array.isArray(value) ? value.map((v, i) => [i, v]) : Object.entries(value);
  entries.forEach(([k, v]) => {
    ids.push(...collectJsonIds(v, depth + 1, Array.isArray(value) ? null : k));
  });
  return ids;
};
